/**
 * Canonical product lines and the raw → canonical mapping.
 *
 * Per LOSAN's instructions:
 *  - The youth line is split in the source as JUNIOR / TEEN BOY / TEEN GIRL but
 *    is commercially ONE line. We collapse them under the label **TEEN**.
 *  - Sales whose collection is blank / "(Blank)" belong to **KIDS**.
 *
 * Keep this the single source of truth: extractor, Node sources and the browser
 * source all call `normalizeLine`, so the merge happens in exactly one place.
 */
const LINE_ALIASES: Record<string, string> = {
  // youth line → TEEN
  'JUNIOR': 'TEEN',
  'TEEN BOY': 'TEEN',
  'TEEN GIRL': 'TEEN',
  'TEEN': 'TEEN',
  // explicit blank markers → KIDS
  '(BLANK)': 'KIDS',
  'BLANK': 'KIDS',
  'EN BLANCO': 'KIDS',
};

export function normalizeLine(rawLine: string | null | undefined): string {
  const v = (rawLine ?? '').trim();
  // Empty / blank collection → KIDS (per LOSAN mapping).
  if (!v) return 'KIDS';
  const upper = v.toUpperCase();
  return LINE_ALIASES[upper] ?? v;
}
